import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@/shadcn-ui/carousel';
import { AspectRatio } from '@radix-ui/react-aspect-ratio';
import MissingImagePlaceholder from '@/catalog/components/missing-image-placeholder';
import ViewCountPill from '@/catalog/components/pdp/vehicle-pills/view-count-pill';

export interface VehicleCarouselProps {
  vehicleImages: string[];
  displayViewCount: boolean;
  viewCount: number;
  className?: string;
}

export function VehicleCarousel({
  vehicleImages,
  displayViewCount,
  viewCount,
  className,
}: VehicleCarouselProps) {
  return (
    <Carousel opts={{ loop: true }} className={className}>
      <div className="absolute z-1 flex gap-[8px] pl-[16px] pt-[16px]">
        {displayViewCount ? <ViewCountPill viewCount={viewCount} /> : null}
      </div>
      <CarouselContent parentClassName="rounded-0 md:rounded-[16px]">
        {vehicleImages.length > 0 ? (
          vehicleImages.map((image, index) => (
            <CarouselItem key={index} className="h-full w-full">
              <AspectRatio ratio={4 / 3}>
                <img src={image} alt="vehicle" />
              </AspectRatio>
            </CarouselItem>
          ))
        ) : (
          <CarouselItem className="h-full w-full">
            <AspectRatio ratio={4 / 3}>
              <MissingImagePlaceholder />
            </AspectRatio>
          </CarouselItem>
        )}
      </CarouselContent>
      <CarouselControls />
    </Carousel>
  );
}
